import { driver } from "driver.js";
import "driver.js/dist/driver.css";

/**
 * Navega al perfil del usuario y marca el tour como pendiente en sessionStorage.
 * @param {Function} navigate - hook useNavigate de react-router-dom
 * @param {string} uid - UID del usuario autenticado
 */
export function startTourPerfil(navigate, uid) {
  const profilePath = `/perfil/${uid}`;

  if (window.location.pathname === profilePath) {
    // Ya está en su perfil — arrancar el tour directamente con un pequeño delay
    // para que el modal tenga tiempo de cerrarse antes de que driver.js tome control
    setTimeout(() => startPerfilTourSteps(), 400);
  } else {
    // Navegar al perfil; el useEffect en Perfil.jsx lo arrancará al cargar
    sessionStorage.setItem("aw_pending_tour", "perfil");
    navigate(profilePath);
  }
}

/**
 * Inicia los pasos del driver.js para el tour de completar perfil.
 * Paso 1: resalta la tab "Información" y la pulsa programáticamente.
 * Paso 2: campo RUT (#numeroTributario).
 * Paso 3: campo Instagram (#instagram).
 */
export function startPerfilTourSteps() {
  // Referencia al handler para poder limpiarlo si el tour se cierra antes de que el usuario actúe
  let tabClickHandler = null;

  const cleanupTabListener = () => {
    const tabBtn = document.querySelector('[aria-controls="tabpanel-2"]');
    if (tabBtn && tabClickHandler) {
      tabBtn.removeEventListener("click", tabClickHandler);
      tabClickHandler = null;
    }
  };

  const driverObj = driver({
    showProgress: true,
    nextBtnText: "Siguiente →",
    prevBtnText: "← Anterior",
    doneBtnText: "¡Listo!",
    progressText: "{{current}} de {{total}}",
    // Evitar que un clic fuera del popover cierre el tour accidentalmente
    allowClose: false,
    onDestroyStarted: () => {
      // Solo se llega aquí mediante el botón X — limpiar y cerrar
      cleanupTabListener();
      driverObj.destroy();
    },
    steps: [
      {
        // Selector controlado vía data-tour-id inyectado desde tabInfo
        element: '[data-tour-id="tab-informacion"]',
        popover: {
          title: "📋 Pulsa la pestaña Información",
          description:
            'Haz clic directamente sobre la pestaña "Información" para ver tus datos de perfil.',
          side: "bottom",
          align: "start",
          // Sin botón "Siguiente" — el tour avanza solo cuando el usuario pulsa la tab
          showButtons: ["close"],
        },
        onHighlightStarted: () => {
          const tabBtn = document.querySelector('[data-tour-id="tab-informacion"]');
          if (!tabBtn) return;
          tabClickHandler = () => {
            cleanupTabListener();
            // Esperar a que el contenido del tab esté en el DOM antes de avanzar
            setTimeout(() => driverObj.moveNext(), 500);
          };
          tabBtn.addEventListener("click", tabClickHandler);
        },
        onDeselected: () => {
          cleanupTabListener();
        },
      },
      {
        element: "#numeroTributario",
        popover: {
          title: "🪪 Tu RUT es obligatorio",
          description:
            "Sin tu RUT no podrás comprar tickets en AppWhoop. Ingrésalo aquí con el formato 12.345.678-9.",
          side: "bottom",
          align: "start",
        },
      },
      {
        element: "#instagram",
        popover: {
          title: "📸 Instagram para invitaciones",
          description:
            "Agrega tu perfil de Instagram para poder postularte a invitaciones en eventos exclusivos.",
          side: "bottom",
          align: "start",
        },
      },
    ],
  });
  driverObj.drive();
}
